import { FC } from "react";

import { Translate } from "@/app/application/Translate";
import { CustomCloseIcon } from "@/features/training/ui";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";

interface FormDialogueProps {
	handleClose: () => void;
	open: boolean;
	title: string;
	translationString: string;
	maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
}

export const FormDialogue: FC<FormDialogueProps> = (props) => {
	const { handleClose, open, title, translationString, maxWidth, children } =
		props;
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<Dialog
			onClose={handleClose}
			open={open}
			fullWidth
			maxWidth={maxWidth ?? "sm"}
			fullScreen={isMobile}
			PaperProps={{
				sx: {
					borderRadius: isMobile ? 0 : 2,
					border: (t) => `1px solid ${t.palette.divider}`,
					backgroundImage: "none",
					overflow: "hidden",
				},
			}}
		>
			<DialogTitle
				id="alert-dialog-title"
				sx={{
					pr: 6,
					py: 1.5,
					borderBottom: (t) => `1px solid ${t.palette.divider}`,
				}}
			>
				<Typography
					variant="h6"
					component="p"
					sx={{ fontWeight: 700, lineHeight: 1.3 }}
				>
					<Translate String={translationString}>{title}</Translate>
				</Typography>
			</DialogTitle>
			<CustomCloseIcon onClick={handleClose} />
			<DialogContent
				dividers
				sx={{
					p: { xs: 2, sm: 2.5 },
					backgroundColor: "background.paper",
				}}
			>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					{children}
				</Box>
			</DialogContent>
		</Dialog>
	);
};
